module.exports = __webpack_public_path__ + "static/img/report02.cd3440ef.png";